export const environment = {
  production: false,
  BASE_URL: 'https://www.api.homolog.supertreinosapp.com',

  API_ENV_URLS: 'https://www.api.homolog.supertreinosapp.com/api',

  dev: 'homolog',

  REC_SITE_KEY: '6LdruZorAAAAAHrcyBz0TFEbl1PmVBVtoTSTAIrT',
  REC_SECRET_KEY: '6LdruZorAAAAABlJEDPvkWQq79HsPnDI7AYcAHl-',
  RECAPTCHA_ENABLED: true,
  MERCADOPAGO_ENABLED: false,
  // MERCADOPAGO_PUBLIC_KEY: 'TEST-c4b95ba9-11a4-4af5-93ee-cefadb99a196',
  MERCADOPAGO_PUBLIC_KEY: 'APP_USR-293834c4-26f9-45ed-9825-35a70836b2dd',
  MERCADOPAGO_CHECKOUT_LINK_ENABLED: false
};
